import { get, delete as remove } from 'axios'
const endpoint = '/notices'

export const getNotification = () => get(`${endpoint}`)
export const notificationDismiss = id => remove(`${endpoint}/${id}`)

export default {
  getNotification,
  notificationDismiss,
}
